import { CHECKOUT_URL } from "../config";
import { trackPixel } from "../lib/metaPixel";

// Every Buy CTA routes to the payment link (falls back to WhatsApp until set)
export default function BuyButton({
    children,
    className = "",
    testId = "buy-button",
}) {
    const external = CHECKOUT_URL.startsWith("http");
    return (
        <a
            data-testid={testId}
            href={CHECKOUT_URL}
            target={external ? "_blank" : undefined}
            rel="noopener noreferrer"
            onClick={() => trackPixel("InitiateCheckout")}
            className={`btn-shine group relative inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-orange-500 via-amber-500 to-amber-400 px-7 py-4 text-base font-bold text-slate-950 shadow-lg shadow-orange-500/30 transition-all duration-300 hover:-translate-y-0.5 hover:from-orange-600 hover:via-amber-600 hover:to-amber-500 active:translate-y-0 sm:text-lg ${className}`}
        >
            {children}
        </a>
    );
}
